import { KEY } from '~/constants';

export const MOCKUP_KEY = `${KEY} API mock`;

export const isDataMockup = () =>
  Boolean(window.localStorage) && Boolean(JSON.parse(localStorage.getItem(MOCKUP_KEY) ?? '0'));
